export interface Component {
  position?: Position;
  direction?: Direction;
}

export enum Position {
  TOP = "top",
  BOTTOM = "bottom",
}

export enum Direction {
  LEFT = "left",
  RIGHT = "right",
}
